import React from 'react';

import { Phone } from '@shared/components/helpers/phone';

import { orderURL } from '@portal/config/routes';
import { LongDistanceMoveFragment, OrderStatusEnum, OrderSubtypeEnum } from '@portal/schema';

import { LineItem, TrackedLinkAction } from '../../line_item';
import { AppointmentDetailsOrder } from '../full_panel';
import { wtLinkParams } from './constants';

function updateInventoryTrackingParams(orderID: string) {
  return {
    ...wtLinkParams,
    objectName: 'update_inventory',
    label: 'Edit',
    value: orderURL(orderID, 'inventory'),
    order_id: orderID,
  };
}

export const OrderInventoryLineItem: React.FC<{
  order: NonNullable<LongDistanceMoveFragment['delivery']>;
  pickupCompleted: boolean;
}> = ({ order, pickupCompleted }) => (
  <LineItem
    label="Items"
    action={
      pickupCompleted &&
      (order.status === OrderStatusEnum.Scheduled || order.status === OrderStatusEnum.Pending) && (
        <TrackedLinkAction
          params={{
            text: 'Edit',
            url: orderURL(order.id, 'inventory'),
            trackingParams: updateInventoryTrackingParams(order.id),
          }}
        />
      )
    }
  >
    {pickupCompleted ? (
      <>
        {order.subtype === OrderSubtypeEnum.Final
          ? 'All items picked up are scheduled for delivery'
          : 'Some items picked up are scheduled for delivery, while the rest will remain in storage'}
      </>
    ) : (
      <div>Pending Pickup Completion</div>
    )}
  </LineItem>
);
